import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-06f11586"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["onClick"]
const _hoisted_2 = { class: "text" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_base_title = _resolveComponent("base-title")!
  const _component_use_svg = _resolveComponent("use-svg")!
  const _component_text_formatter = _resolveComponent("text-formatter")!

  return (_openBlock(), _createElementBlock("section", null, [
    _createVNode(_component_base_title, null, {
      default: _withCtx(() => [
        _createTextVNode(_toDisplayString(_ctx.group.title), 1)
      ]),
      _: 1
    }),
    _createElementVNode("ul", null, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.group.questions, (question) => {
        return (_openBlock(), _createElementBlock("li", {
          key: question.question,
          class: "group"
        }, [
          _createElementVNode("div", null, [
            _createElementVNode("button", {
              class: "toggle-button",
              onClick: ($event: any) => (_ctx.toggleQuestion(question))
            }, [
              _createElementVNode("span", _hoisted_2, _toDisplayString(question.question), 1),
              _createVNode(_component_use_svg, {
                svg: _ctx.chevronIcon(question)
              }, null, 8, ["svg"])
            ], 8, _hoisted_1),
            _createVNode(_Transition, {
              name: "accordion",
              onBeforeEnter: _ctx.beforeEnter,
              onEnter: _ctx.enter,
              onBeforeLeave: _ctx.beforeLeave,
              onLeave: _ctx.leave
            }, {
              default: _withCtx(() => [
                (_ctx.isVisibleAnswer(question))
                  ? (_openBlock(), _createBlock(_component_text_formatter, {
                      key: 0,
                      content: question.answer,
                      class: "answer"
                    }, null, 8, ["content"]))
                  : _createCommentVNode("", true)
              ]),
              _: 2
            }, 1032, ["onBeforeEnter", "onEnter", "onBeforeLeave", "onLeave"])
          ])
        ]))
      }), 128))
    ])
  ]))
}